import React, { useState } from 'react';
import { Navbar } from '../components/Navbar';
import women_empowerment from '../assets/women_empowerment.jpg';
import { FaHome } from "react-icons/fa";
import Footer from '../components/Footer';
import axios from 'axios'

const Contact = () => {

    const [formData, setFormData] = useState({
        name: "",
        loanType: "",
        phone: "",
        description: ""
    });

    // update values dynamically
    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [id]: value
        }));
    };

    // handle submit
    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log("Form Submitted:", formData);

        // You can send formData to API here
        // axios.post("/contact", formData)
        const res = await axios.post('https://api.siddhabhairabistore.com/surbhi/add-contact', formData);

        // setCodeConductList(prev => [
        //     ...prev,
        //     { id: res.data.insertId, ...formData }
        // ]);

        alert("Form submitted successfully!");

        setFormData({
            name: "",
            loanType: "",
            phone: "",
            description: ""
        })
    };

    return (
        <>
            {/* Hero Section */}
            <div
                style={{
                    background: `url(${women_empowerment}) no-repeat center center / cover`,
                    height: "70vh",
                    position: "relative",
                }}
            >
                <Navbar />
                <section
                    className="d-flex flex-column flex-lg-row align-items-center justify-content-between container-lg"
                    style={{
                        color: "white",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "100%",
                    }}
                >
                    <div style={{ position: "relative", zIndex: 2, backgroundColor: "rgba(0,0,0,0.5)", padding: "20px 30px", borderRadius: "10px" }}>
                        <p style={{ fontSize: "1rem", letterSpacing: "1px", marginBottom: "10px" }}>
                            <FaHome className="text-info" /> <span style={{ color: "#00bfff" }}>Home</span> &gt; CONTACT US
                        </p>
                        <h1 style={{ fontSize: "3rem", fontWeight: 700, margin: 0 }}>Contact Us</h1>
                    </div>
                </section>
            </div>

            {/* Contact Form + Map Section */}
            <section className="py-5" style={{ backgroundColor: "#f8f9fa" }}>
                <div className="container">
                    <div className="row g-4">

                        {/* Form */}
                        <div className="col-lg-6">
                            <div className="card shadow-sm p-4 p-md-5 h-100">
                                <h2 className="mb-4 text-center">Get in Touch</h2>

                                <form onSubmit={handleSubmit}>

                                    <div className="mb-3">
                                        <label htmlFor="name" className="form-label">Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            placeholder="Enter your name"
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="loanType" className="form-label">Select Loan Type</label>
                                        <select
                                            className="form-select"
                                            id="loanType"
                                            value={formData.loanType}
                                            onChange={handleChange}
                                        >
                                            <option value="">---Select---</option>
                                            <option value="Personal Loan">Personal Loan</option>
                                            <option value="Loan Against Property Loan">Loan Against Property Loan</option>
                                            <option value="Business Loan">Business Loan</option>
                                            <option value="Housing & Consumer Loan">Housing & Consumer Loan</option>
                                        </select>
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="phone" className="form-label">Phone</label>
                                        <input
                                            type="tel"
                                            className="form-control"
                                            id="phone"
                                            value={formData.phone}
                                            onChange={handleChange}
                                            placeholder="Enter your phone number"
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="description" className="form-label">Description</label>
                                        <textarea
                                            className="form-control"
                                            id="description"
                                            rows="5"
                                            value={formData.description}
                                            onChange={handleChange}
                                            placeholder="Your message or query"
                                        />
                                    </div>

                                    <div className="text-center">
                                        <button type="submit" className="btn btn-primary btn-lg px-5">Submit</button>
                                    </div>

                                </form>
                            </div>
                        </div>

                        {/* Map */}
                        {/* Map */}
                        <div className="col-lg-6">
                            <div className="card shadow-sm h-100">
                                <iframe
                                    title="Company Location"
                                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14407.406795858384!2d81.851821!3d25.476627!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399acbbbe5f47991%3A0x14a7efc27c9c25e6!2sDr.%20Rakesh%20Chandra!5e0!3m2!1sen!2sus!4v1764674957961!5m2!1sen!2sus"
                                    width="100%"
                                    height="100%"
                                    style={{ border: 0, minHeight: "400px", borderRadius: "5px" }}
                                    allowFullScreen=""
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                ></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </>
    );
};

export default Contact;